'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    activateText: 'Обновить сразу после выпуска',
    deactivateText: 'Потяните вниз, чтобы обновить',
    finishText: 'Завершить обновление'
};
module.exports = exports['default'];